import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef } from '@angular/core';
import { LiveFieldEvent, MeetList } from '@athleticnet/athletic-live-api-models';
import { LiveRunEvent } from '@athleticnet/athletic-live-api-models/lib/models/firebase/live-run-event.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LiveEventListComponent } from '../../live/live-event-list/live-event-list.component';
import { MeetBannerAdComponent } from '../../shared/ads/meet-banner-ad/meet-banner-ad.component';
import { PageTitleComponent } from '../../shared/page-title/page-title.component';
import { CurrentMeetService } from '../../shared/services/current-meet.service';
import { IsDesktopService } from '../../shared/services/is-desktop.service';
import { FollowListComponent } from '../follow-list/follow-list.component';
import { MeetDashboardEventListComponent } from '../meet-dashboard-event-list/meet-dashboard-event-list.component';
import { ScoresDashletComponent } from '../scores-dashlet/scores-dashlet.component';
import { MeetDatePipe } from '../../shared/pipes/meet-date.pipe';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { AuthService } from 'src/app/shared/anet/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-meet-dashboard',
  templateUrl: './meet-dashboard.component.html',
  styleUrls: ['./meet-dashboard.component.scss'],
  standalone: true,
  imports: [
    MeetDashboardEventListComponent,
    PageTitleComponent,
    AsyncPipe,
    ScoresDashletComponent,
    NgbAccordionModule,
    FontAwesomeModule,
    LiveEventListComponent,
    FollowListComponent,
    MeetBannerAdComponent,
    MeetDatePipe,
  ],
})
export class MeetDashboardComponent {
  currentMeet$!: Observable<MeetList | null>;
  desktop$!: Observable<boolean>;
  liveRunEvents$!: Observable<LiveRunEvent[] | null>;
  liveFieldEvents$!: Observable<LiveFieldEvent[] | null>;
  overrideTitle: string = $localize`:@@pageTitle.meetDashboard:Meet Dashboard`;
  followDashletOpen = false;
  authSub!: Subscription;
  followCount = 0;

  constructor(
    private currentMeetService: CurrentMeetService,
    private isDesktopService: IsDesktopService,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    destroyRef: DestroyRef,
  ) {
    const localUserStorage = this.localStorageService.getLocalUserStorage();
    if (localUserStorage) {
      this.followDashletOpen = localUserStorage.followDashletOpen;
    }

    this.authSub = this.authService.updateFollowInfo.pipe(takeUntilDestroyed(destroyRef)).subscribe((followInfo) => {
      if (followInfo) {
        this.followCount = followInfo.athletes.length + followInfo.teams.length + followInfo.aliveFollows.length;
      } else {
        this.followCount = 0;
      }
    });
  }

  ngOnInit() {
    this.desktop$ = this.isDesktopService.isDesktop;
    this.currentMeet$ = this.currentMeetService.updateMeet;
    this.liveRunEvents$ = this.currentMeetService.updateLiveRunEvents;
    this.liveFieldEvents$ = this.currentMeetService.updateLiveFieldEvents;
  }

  toggleFollowDashlet() {
    this.followDashletOpen = !this.followDashletOpen;
    this.localStorageService.storeFollowDashletOpen(this.followDashletOpen);
  }

  protected readonly environment = environment;
}
